<template>
    <td-dialog
        :lockScroll="false"
        :title="$t(title)"
        :before-close="groupDialogClose"
        :visible.sync="dialogVisible"
        :width="dialogWidth"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="fromGroupInfo" label-position="right" label-width="95px" ref="fromGroupInfo" :rules="rules">
            <el-form-item :label="$t('extendCommon.EXTEND_GROUP_FLG')" prop="sGroupFlg">
                <el-col :span="17">
                    <td-input v-model="fromGroupInfo.sGroupFlg" :disabled="flgDisabled"></td-input>
                </el-col>
                <el-col :span="3">
                    <td-checkbox v-if="autoShow" v-model="flgChecked" ref="flgChecked" @change="autoCreateGroupFlg">{{ $t('extendCommon.AUTO_CREATE') }}</td-checkbox>
                </el-col>
            </el-form-item>
            <el-form-item :label="$t('extendCommon.EXTEND_GROUP_NAME')" prop="sName">
                <td-input v-model="fromGroupInfo.sName"> </td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('fromGroupInfo')" :loading="submitLoading">{{ $t('extendCommon.SAVE') }}</td-button>
            <td-button @click="groupDialogClose">{{ $t('extendCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import groupApi from './../assets/api.js';
export default {
    props: ['title', 'dialogVisible', 'editItem', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.autoShow = false;
            this.flgDisabled = true;
            this.initEditData();
            this.dialogWidth = '340px';
        }
    },
    // 定义变量
    data() {
        let validateGroupFlg = (rule, value, callback) => {
            if (this.flgDisabled == undefined || this.flgDisabled) {
                callback();
                return;
            }
            let sId = '';
            if (!this.isAddData) {
                sId = this.fromGroupInfo.sId;
            }
            let param = {
                sId: sId,
                sGroupFlg: value
            };
            groupApi.checkGroupInfo(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/checkGroupInfo', response.data.statusMessage);
                    return;
                }
                if (response.data.count > 0) {
                    callback(this.$t('extendError.ERROR_GROUP_FLG_EXIST'));
                } else {
                    callback();
                }
            });
        };
        return {
            // 表单信息
            fromGroupInfo: {
                sName: '',
                sGroupFlg: ''
            },
            submitLoading: false, // 保存按钮是否为加载状态
            flgDisabled: false,
            autoShow: true,
            flgChecked: false,
            dialogWidth: '430px',
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_GROUP_NAME'), trigger: 'blur' },
                    { pattern: window.tdExtend.regex.CAPTION_RULE, message: this.$t('extendRegex.PLEASE_INPUT_CREDENT_NUM_RESET'), trigger: 'blur' }
                ],
                sGroupFlg: [
                    { required: true, message: this.$t('extendError.ERROR_PLEASE_INPUT_GROUP_FLG'), trigger: 'blur' },
                    { pattern: window.tdExtend.regex.ENGLISH_AND_NUM_LINE, message: this.$t('extendRegex.ONLY_ENGLISH_NUM_LINE') },
                    { validator: validateGroupFlg, trigger: 'blur' }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.fromGroupInfo.sId = this.editItem.sId;
            this.fromGroupInfo.sName = this.editItem.sName;
            this.fromGroupInfo.sGroupFlg = this.editItem.sGroupFlg;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    var content = {
                        sId: this.getUUID(),
                        sName: this.fromGroupInfo.sName,
                        sGroupFlg: this.fromGroupInfo.sGroupFlg
                    };
                    if (this.flgChecked) {
                        content.sGroupFlg = this.getUUID();
                    }
                    if (this.isAddData) {
                        groupApi.insertExtendGroup(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('extendManage/insertExtendGroup', response.data.statusMessage);
                                this.submitLoading = false;
                                return;
                            }
                            this.submitLoading = false;
                            this.$message({ showClose: true, message: this.$t('extendCommon.ADD_SUCCESS'), type: 'success' });
                            this.groupDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('addTableNode', content);
                        });
                    } else {
                        content.sId = this.fromGroupInfo.sId;
                        groupApi.updateExtendGroup(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('extendManage/updateExtendGroup', response.data.statusMessage);
                                this.submitLoading = false;
                                return;
                            }
                            this.submitLoading = false;
                            this.$message({ showClose: true, message: this.$t('extendCommon.MODIFY_SUCCESS'), type: 'success' });
                            this.groupDialogClose();
                            //回调父页面的初始化树形接口
                            this.$emit('updateTableNode', content);
                        });
                    }
                }
            });
        },
        // 自定义标识
        autoCreateGroupFlg() {
            if (this.isAddData) {
                if (this.flgDisabled) {
                    this.flgDisabled = false;
                    this.rules.sGroupFlg[0].required = true;
                } else {
                    this.fromGroupInfo.sGroupFlg = null;
                    this.flgDisabled = true;
                    this.rules.sGroupFlg[0].required = false;
                }
            }
        },
        // 获取UUID
        getUUID() {
            return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        // 关闭窗口之前需要调用的方法
        groupDialogClose() {
            this.$emit('groupDialogClose');
            this.$refs['fromGroupInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style></style>
